import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { isFunction, isString } from '@impuls-coach/util-is';
import Icon from 'components/atoms/Icon';

export type CtaProps = {
	text?: string;
	icon?: string;
	size?: string;
	routeTo?: string;
	delegate?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
	label?: string;
	disabled?: boolean;
	loading?: boolean;
};

const Cta = ({ icon, text, size, delegate, routeTo, label, disabled = false, loading = false }: CtaProps) => {
	const useLink = !isFunction(delegate) && isString(routeTo);

	const renderInnerContent = () => {
		return (
			<div className="a-cta__ring">
				<div className="a-cta__circle">
					<div className="a-cta__text" dangerouslySetInnerHTML={{ __html: text! }} />
					<div className="a-cta__icon">{icon && <Icon iconName={icon} />}</div>
				</div>
				<span className="a-cta__label">{label}</span>
			</div>
		);
	};

	const className = (): string => {
		const out: Array<string> = ['a-cta'];
		if (size) {
			out.push(`a-cta--${size}`);
		}
		if (!useLink) {
			out.push('a-cta--button');
		}
		if (disabled) {
			out.push('state-a-cta--disabled');
		}
		if (loading) {
			out.push('state-a-cta--loading');
		}
		if (loading) {
			out.push('state-a-cta--loading');
		}
		return out.join(' ');
	};

	if (useLink) {
		return (
			<RouterLink className={className()} to={routeTo!}>
				{renderInnerContent()}
			</RouterLink>
		);
	}

	return (
		<a
			className={className()}
			onClick={
				disabled
					? () => {
							/* noop */
					  }
					: delegate!
			}
		>
			{renderInnerContent()}
		</a>
	);
};

export default Cta;
